module.exports = __webpack_public_path__ + "static/img/idcard-2.146886f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/v2/idcard-2.png
// module id = 6/9e
// module chunks = 167